<template>
  <p class="policies" :style="computedStyles">
    By using our site, you agree to our
    <a href="https://www.homegauge.com/hg-terms.html" target="_blank">Terms of Service</a>,
    and
    <a href="https://www.homegauge.com/privacy.html" target="_blank">Privacy Policy</a>
  </p>
</template>

<script>
export default {
  props: {
    fontColor: {
      type: String,
      default: '#333',
    },
    embolden: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    computedStyles() {
      const emboldenedFontWeight = 600;
      return {
        'font-weight': this.embolden ? emboldenedFontWeight : 'normal',
        color: this.fontColor,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.policies {
  display: block;
  font-family: 'Barlow Semi Condensed', sans-serif;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 0;
  a {
    color: #29abe2;
  }
}
</style>
